import { Entity, EntityId } from 'entities-next/common'

export type UserGroup = Entity & {
  readonly name: string
  readonly sortedFunnelStageIds: EntityId[]
  readonly description?: string
  readonly logoUrl?: string
  readonly websiteUrl?: string
}

export type ApiUserGroup = UserGroup

export const USER_GROUP_CACHE_STORE_ID = 'userGroup'
